import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Icon,
    Card,
    Form,
    Descriptions,
    Switch,
    Modal,
    Spin,
    Button,
    InputNumber,
    Radio,
    Statistic,
    Tabs,
    DatePicker,
    Tag,
} from "antd";
export default class UnionDetail extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        integralLoading: false, // 积分记录是否加载中
        operateLoading: false, // 操作记录是否加载中
        dataRecordExportLoading: false, // 数据记录导出是否加载中
        integralQueryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        operateQueryParams: {
            // 操作记录查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
        },
        formData: {
            // 表单数据
            avail_fee_rate: undefined,
            avail_ins_rate: undefined,
            avail_cowboy_rate: undefined,
            ins_mod: undefined,
            cowboy_mod: undefined,
            no_day_limit: undefined,
            no_week_limit: undefined,
            day_limit: undefined,
            week_limit: undefined,
            add_day_left: undefined,
            add_week_left: undefined,
        },
        unionInfo: {}, // 联盟信息
        activityConfig: [], // 活动配置
        handCardConfig: {}, // 牌局配置
        integralData: [], // 积分记录
        operateData: [], // 操作记录
    };

    async componentDidMount () {
        await this.fetchUnionInfo();
        this.fetchIntegralData();
        this.fetchOperateData();
    }

    componentDidUpdate (prevProps) {
        // 监听url变化
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.location.reload();
        }
    }

    /**
     * 获取联盟信息
     */
    fetchUnionInfo = async () => {
        this.setState({ loading: true });
        let res = await axios.get(
            `/v1/api/union_info_detail/${this.props.match.params.union_id}`
        );
        this.setState({
            loading: false,
            unionInfo: res.data || {},
            activityConfig: res.data && res.data.active_setting ? res.data.active_setting : [],
            handCardConfig: res.data && res.data.block_game_conf ? res.data.block_game_conf : {},
        });
    };

    /**
     * 获取积分记录
     */
    fetchIntegralData = () => {
        this.setState({ integralLoading: true });
        axios
            .get("/v1/api/union_point_log", {
                params: {
                    union_id: this.state.unionInfo.union_id,
                    ...this.state.integralQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    integralLoading: false,
                    integralQueryParams: { ...this.state.integralQueryParams, total: res.count || 0 },
                    integralData: res.data || [],
                });
            });
    };

    /**
     * 获取操作记录
     */
    fetchOperateData = () => {
        this.setState({ operateLoading: true });
        axios
            .get("/v1/api/union_op_log", {
                params: {
                    union_id: this.state.unionInfo.union_id,
                    ...this.state.operateQueryParams,
                    begin_time:
                        this.state.operateQueryParams.date[0] &&
                        this.state.operateQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.operateQueryParams.date[1] &&
                        this.state.operateQueryParams.date[1].startOf("day").valueOf() / 1000,
                    date: [],
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    operateLoading: false,
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        total: res.count || 0,
                    },
                    operateData: res.data || [],
                });
            });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === "editProportion") {
                    // 更新占比
                    axios
                        .patch("/v1/api/union_avail_rate", {
                            union_id: Number(this.state.unionInfo.union_id),
                            avail_fee_rate: Number(values.avail_fee_rate),
                            avail_ins_rate: Number(values.avail_ins_rate),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate),
                            ins_mod: Number(values.ins_mod),
                            cowboy_mod: Number(values.cowboy_mod),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchUnionInfo();
                            }
                        });
                } else if (
                    this.state.type === "sendIntegral" ||
                    this.state.type === "recycleIntegral"
                ) {
                    // 发放、回收积分
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendIntegral"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.unionInfo.union_id),
                            kind: 0,
                            level: 0,
                            club: 0,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchUnionInfo();
                            }
                        });
                } else if (
                    this.state.type === "sendDiamond" ||
                    this.state.type === "recycleDiamond"
                ) {
                    // 发放、回收钻石
                    axios
                        .patch("/v1/api/diamond/super_union/union", {
                            amount:
                                this.state.type === "sendDiamond"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            id: Number(this.state.unionInfo.union_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchUnionInfo();
                            }
                        });
                } else if (this.state.type === "editLossLimit") {
                    // 编辑亏损限额
                    axios
                        .patch("/v1/api/union_loss_limit", {
                            union_id: Number(this.state.unionInfo.union_id),
                            no_day_limit: !values.no_day_limit,
                            no_week_limit: !values.no_week_limit,
                            day_limit: Number(values.day_limit),
                            week_limit: Number(values.week_limit),
                            add_day_left: Number(values.add_day_left),
                            add_week_left: Number(values.add_week_left),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchUnionInfo();
                            }
                        });
                } else if (this.state.type === "exportDataRecord") {
                    // 获取导出的数据记录路径key
                    axios
                        .get('/v1/api/export_union_club_user_all_log_list', {
                            params: {
                                user_id: this.state.unionInfo.user_id,
                                club_id: this.state.unionInfo.club_id,
                                begin_time: values.date[0] && values.date[0].startOf("day").valueOf() / 1000,
                                end_time: values.date[1] && values.date[1].startOf("day").valueOf() / 1000,
                            }
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                this.handleClose();
                                notification.open({
                                    key,
                                    duration: 0,
                                    message: this.props.language["hint"],
                                    description: this.props.language["exportLoaddingMessage"],
                                    icon: <Icon type="loading" style={{ color: '#108ee9' }} />,
                                    onClose: () => {
                                        if (timer) clearInterval(timer);
                                        timer = undefined;
                                        this.setState({ dataRecordExportLoading: false });
                                    }
                                });
                                if (!timer) {
                                    this.handleExportDataRecord(res.file_id);
                                    timer = setInterval(() => {
                                        this.handleExportDataRecord(res.file_id);
                                    }, 2000);
                                }
                            }
                        });
                }
            }
        });
    };

    /**
     * 根据key进行导出数据记录
     */
    handleExportDataRecord = (file_id) => {
        this.setState({ dataRecordExportLoading: true });
        axios.get('/v1/api/get_export_union_club_user_all_log_list_url', {
            params: {
                file_id,
            },
        })
            .then((res) => {
                if (res.url) {
                    notification.close(key);
                    if (timer) clearInterval(timer);
                    timer = undefined;
                    this.setState({ dataRecordExportLoading: false });
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    }

    /**
     * 更新活动配置
     */
    handleUpdateActivityConfig = (item, value) => {
        axios
            .patch("/v1/api/set_union_active_status", {
                union_id: Number(this.props.match.params.union_id),
                active_id: item.active_id,
                status: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["updateSuccessMessage"]);
                    this.fetchUnionInfo();
                }
            });
    };

    /**
     * 更新配置
     */
    handleUpdateConfig = (kind, level, value) => {
        axios
            .patch("/v1/api/union_game_block", {
                union_id: Number(this.props.match.params.union_id),
                game_kind: kind,
                option_name: level,
                is_blocked: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["updateSuccessMessage"]);
                    this.fetchUnionInfo();
                }
            });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type) => {
        let title;
        switch (type) {
            case "sendIntegral":
                title = this.props.language["sendIntergral"];
                break;
            case "recycleIntegral":
                title = this.props.language["recycleIntergral"];
                break;
            case "sendDiamond":
                title = this.props.language["sendDiamond"];
                break;
            case "recycleDiamond":
                title = this.props.language["recycleDiamond"];
                break;
            case "editProportion":
                title = this.props.language["editProportion"];
                break;
            case "editLossLimit":
                title = this.props.language["editLossLimit"];
                break;
        }
        this.setState({
            show: true,
            type,
            title,
            formData: {
                avail_fee_rate: this.state.unionInfo.avail_fee_rate,
                avail_ins_rate: this.state.unionInfo.avail_ins_rate,
                avail_cowboy_rate: this.state.unionInfo.avail_cowboy_rate,
                ins_mod: this.state.unionInfo.ins_mod || undefined,
                cowboy_mod: this.state.unionInfo.cowboy_mod || undefined,
                no_day_limit: !this.state.unionInfo.loss_info.no_day_limit,
                no_week_limit: !this.state.unionInfo.loss_info.no_week_limit,
                day_limit: this.state.unionInfo.loss_info.day_loss_limit,
                week_limit: this.state.unionInfo.loss_info.week_loss_limit,
                add_day_left: this.state.unionInfo.loss_info.day_loss_quota,
                add_week_left: this.state.unionInfo.loss_info.week_loss_quota,
            },
        });
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false });
    };

    /**
      * 设置查询数据
      */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "operate") {
            // 操作记录
            this.setState(
                {
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchOperateData()
            );
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "integral") {
            // 积分记录
            this.setState(
                {
                    integralQueryParams: {
                        ...this.state.integralQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchIntegralData()
            );
        } else if (type === "operate") {
            // 操作记录
            this.setState(
                {
                    operateQueryParams: {
                        ...this.state.operateQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchOperateData()
            );
        }
    };

    render () {
        return (
            <Spin spinning={this.state.loading}>
                <div className='p10'>
                    <Row gutter={10}>
                        {/* 左侧 */}
                        <Col span={isMobileDevice() ? 24 : 12}>
                            {/* 联盟信息 */}
                            <Card
                                title={
                                    <h2>{this.props.language["unionInfo"]}</h2>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    <Col span={isMobileDevice() ? 24 : 12}>
                                        <Descriptions size="small" column={1}>
                                            <Descriptions.Item label={this.props.language["unionId"]}>
                                                {this.state.unionInfo.union_id}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={this.props.language["unionName"]}>
                                                {this.state.unionInfo.union_name}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={this.props.language["unionOwnerId"]}>
                                                {this.state.unionInfo.owner_id}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={this.props.language["unionOwnerName"]}>
                                                {this.state.unionInfo.owner_name}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={this.props.language["createTime"]}>
                                                {this.state.unionInfo.created_at}
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 12}>
                                        <div className="number-box-list">
                                            {/* 可用占比 */}
                                            <p className="title">{this.props.language["availableProportion"]}</p>
                                            <Button className="btn"
                                                shape="circle"
                                                icon="edit"
                                                type="primary"
                                                ghost
                                                onClick={() => this.handleShow("editProportion")}
                                            >
                                            </Button>
                                            <div className="value-list">
                                                <div className="value-item">
                                                    <Statistic
                                                        value={Number(
                                                            this.state.unionInfo.avail_fee_rate || 0
                                                        )}
                                                        suffix="%"
                                                    />
                                                    <p className="label">
                                                        {this.props.language["serviceFee"]}
                                                    </p>
                                                </div>
                                                <div className="value-item">
                                                    <Statistic
                                                        value={Number(
                                                            this.state.unionInfo.avail_ins_rate || 0
                                                        )}
                                                        suffix="%"
                                                    />
                                                    <p className="label">
                                                        {this.props.language["insurance"]}
                                                    </p>
                                                </div>
                                                <div className="value-item">
                                                    <Statistic
                                                        value={Number(
                                                            this.state.unionInfo.avail_cowboy_rate || 0
                                                        )}
                                                        suffix="%"
                                                    />
                                                    <p className="label">{this.props.language["cowboy"]}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            {/* 概况 */}
                            <Card
                                className="mt10"
                                title={
                                    <h2>{this.props.language["overview"]}</h2>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    {/* 俱乐部 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.club_num || 0)}
                                                />
                                                <p className="label">{this.props.language["club"]}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 玩家 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.user_num || 0)}
                                                />
                                                <p className="label">{this.props.language["player"]}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 玩家盈亏 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.profit || 0)}
                                                    valueStyle={{
                                                        color:
                                                            this.state.unionInfo.profit > 0
                                                                ? "#cf1322"
                                                                : this.state.unionInfo.profit < 0
                                                                    ? "#3f8600"
                                                                    : "",
                                                    }}
                                                />
                                                <p className="label">
                                                    {this.props.language["playerProfit"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 牛仔盈亏 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.cb_profit || 0)}
                                                    valueStyle={{
                                                        color:
                                                            this.state.unionInfo.cb_profit > 0
                                                                ? "#cf1322"
                                                                : this.state.unionInfo.cb_profit < 0
                                                                    ? "#3f8600"
                                                                    : "",
                                                    }}
                                                />
                                                <p className="label">
                                                    {this.props.language["cowboysProfit"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 服务费 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.fee || 0)}
                                                    valueStyle={{
                                                        color:
                                                            this.state.unionInfo.fee > 0
                                                                ? "#cf1322"
                                                                : this.state.unionInfo.fee < 0
                                                                    ? "#3f8600"
                                                                    : "",
                                                    }}
                                                />
                                                <p className="label">
                                                    {this.props.language["serviceFee"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 保险 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.ins_profit || 0)}
                                                    valueStyle={{
                                                        color:
                                                            this.state.unionInfo.ins_profit > 0
                                                                ? "#cf1322"
                                                                : this.state.unionInfo.ins_profit < 0
                                                                    ? "#3f8600"
                                                                    : "",
                                                    }}
                                                />
                                                <p className="label">
                                                    {this.props.language["insurance"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 柜台积分 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>
                                            {this.props.language["counterPoint"]}
                                        </h2>
                                        <div>
                                            <Button
                                                className="btn-green-ghost"
                                                ghost
                                                onClick={() => this.handleShow("sendIntegral")}
                                            >
                                                {this.props.language["sendIntergral"]}
                                            </Button>
                                            <Button
                                                className="ml10"
                                                type="danger"
                                                ghost
                                                onClick={() => this.handleShow("recycleIntegral")}
                                            >
                                                {this.props.language["recycleIntergral"]}
                                            </Button>
                                        </div>
                                    </Row>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle" justify="space-between">
                                    {/* 联盟持有 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.union_point || 0)}
                                                />
                                                <p className="label">
                                                    {this.props.language["unionOwn"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 俱乐部持有 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.club_point || 0)}
                                                />
                                                <p className="label">
                                                    {this.props.language["clubOwn"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 超级代理持有 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(
                                                        this.state.unionInfo.super_agent_point || 0
                                                    )}
                                                />
                                                <p className="label">
                                                    {this.props.language["superProxyOwn"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 代理持有 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.agent_point || 0)}
                                                />
                                                <p className="label">
                                                    {this.props.language["proxyOwn"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 玩家持有 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.member_chips || 0)}
                                                />
                                                <p className="label">
                                                    {this.props.language["palyerOwn"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 柜台钻石 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>
                                            {this.props.language["counterDiamond"]}
                                        </h2>
                                        <div>
                                            <Button
                                                className="btn-green-ghost"
                                                ghost
                                                onClick={() => this.handleShow("sendDiamond")}
                                            >
                                                {this.props.language["sendDiamond"]}
                                            </Button>
                                            <Button
                                                className="ml10"
                                                type="danger"
                                                ghost
                                                onClick={() => this.handleShow("recycleDiamond")}
                                            >
                                                {this.props.language["recycleDiamond"]}
                                            </Button>
                                        </div>
                                    </Row>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    {/* 柜台钻石 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                <Statistic
                                                    value={Number(this.state.unionInfo.diamond || 0)}
                                                />
                                                <p className="label">
                                                    {this.props.language["counterDiamond"]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 亏损设置 */}
                            <Card
                                className="mt10"
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>
                                            {this.props.language["lossSetting"]}
                                        </h2>
                                        <div>
                                            <Button
                                                type="primary"
                                                ghost
                                                onClick={() => this.handleShow("editLossLimit")}
                                            >
                                                {this.props.language["edit"]}
                                            </Button>
                                        </div>
                                    </Row>
                                }
                                type="inner"
                            >
                                <Row type="flex" align="middle">
                                    {/* 日亏损限制 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                {this.state.unionInfo.loss_info && (
                                                    <>
                                                        {this.state.unionInfo.loss_info.no_day_limit ?
                                                            <h2 style={{ lineHeight: '45px' }}>无限制</h2>
                                                            :
                                                            <Statistic
                                                                value={Number(
                                                                    this.state.unionInfo.loss_info.day_loss_limit || 0
                                                                )}
                                                            />
                                                        }
                                                        <p className="label">
                                                            {this.props.language["dayLossLimit"]}
                                                            {this.props.getLanguage(
                                                                "remainingQuota",
                                                                this.state.unionInfo.loss_info.no_day_limit ? '无限制' : this.state.unionInfo.loss_info.day_loss_quota || 0
                                                            )}
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* 周亏损限制 */}
                                    <div className="number-box-list">
                                        <div className="value-list">
                                            <div className="value-item">
                                                {this.state.unionInfo.loss_info && (
                                                    <>
                                                        {this.state.unionInfo.loss_info.no_week_limit ?
                                                            <h2 style={{ lineHeight: '45px' }}>无限制</h2>
                                                            :
                                                            <Statistic
                                                                value={Number(
                                                                    this.state.unionInfo.loss_info.week_loss_limit || 0
                                                                )}
                                                            />
                                                        }
                                                        <p className="label">
                                                            {this.props.language["weekLossLimit"]}
                                                            {this.props.getLanguage(
                                                                "remainingQuota",
                                                                this.state.unionInfo.loss_info.no_week_limit ? '无限制' : this.state.unionInfo.loss_info.week_loss_quota || 0
                                                            )}
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Card>

                            {/* 活动开关 */}
                            <Card
                                className="mt20"
                                title={
                                    <h2>{this.props.language["activitySwitch"]}</h2>
                                }
                                type="inner"
                            >
                                {this.state.activityConfig.map((item, index) => (
                                    <Row className='mb10' type="flex" align="middle" justify="space-between" key={index}>
                                        <Row type="flex" align="middle">
                                            <h3>{item.active_name}</h3>
                                            {item.extra_desc && <span>（{item.extra_desc}）</span>}
                                        </Row>
                                        <Row type="flex" align="middle">
                                            {item.changed && <Tag color="blue">{this.props.language["effectiveTomorrow"]}</Tag>}
                                            <Switch
                                                checked={item.status}
                                                onChange={(value) =>
                                                    this.handleUpdateActivityConfig(item, value)
                                                }
                                            />
                                        </Row>
                                    </Row>
                                ))}
                            </Card>

                            {/* 牌局屏蔽 */}
                            <Card
                                className="mt10"
                                title={
                                    <h2>
                                        {this.props.language["shieldGamble"]}
                                    </h2>
                                }
                                type="inner"
                            >
                                <Row gutter={10}>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["nlh"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.nlh &&
                                                        this.state.handCardConfig.nlh.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(1, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.nlh &&
                                                        this.state.handCardConfig.nlh.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(1, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.nlh &&
                                                        this.state.handCardConfig.nlh.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(1, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["bbLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.nlh &&
                                                        this.state.handCardConfig.nlh.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(1, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["plo"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.plo &&
                                                        this.state.handCardConfig.plo.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(4, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.plo &&
                                                        this.state.handCardConfig.plo.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(4, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.plo &&
                                                        this.state.handCardConfig.plo.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(4, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["bbLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.plo &&
                                                        this.state.handCardConfig.plo.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(4, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["six"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["anteLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.six_plus &&
                                                        this.state.handCardConfig.six_plus.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(2, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["anteLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.six_plus &&
                                                        this.state.handCardConfig.six_plus.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(2, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["anteLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.six_plus &&
                                                        this.state.handCardConfig.six_plus.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(2, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["anteLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.six_plus &&
                                                        this.state.handCardConfig.six_plus.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(2, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["ofc"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["scoreLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.ofc &&
                                                        this.state.handCardConfig.ofc.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(6, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["scoreLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.ofc &&
                                                        this.state.handCardConfig.ofc.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(6, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["scoreLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.ofc &&
                                                        this.state.handCardConfig.ofc.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(6, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["scoreLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.ofc &&
                                                        this.state.handCardConfig.ofc.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(6, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["aof"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.aof &&
                                                        this.state.handCardConfig.aof.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(8, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.aof &&
                                                        this.state.handCardConfig.aof.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(8, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["bbLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.aof &&
                                                        this.state.handCardConfig.aof.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(8, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["bbLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.aof &&
                                                        this.state.handCardConfig.aof.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(8, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["cowboy"]}</h3>}
                                            type="inner"
                                            className='mb10'
                                        >
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>Cowboy</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.cowboy &&
                                                        this.state.handCardConfig.cowboy
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(3, "", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col span={isMobileDevice() ? 24 : 8}>
                                        <Card
                                            title={<h3>{this.props.language["mtt"]}</h3>}
                                            type="inner"
                                        >
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["feeMatch"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.mtt &&
                                                        this.state.handCardConfig.mtt.free
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(5, "free", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["applyLevel1"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.mtt &&
                                                        this.state.handCardConfig.mtt.micro
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(5, "micro", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["applyLevel2"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.mtt &&
                                                        this.state.handCardConfig.mtt.small
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(5, "small", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between" className="mb10">
                                                <p>{this.props.language["applyLevel3"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.mtt &&
                                                        this.state.handCardConfig.mtt.middle
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(5, "middle", value)
                                                    }
                                                />
                                            </Row>
                                            <Row type="flex" align="middle" justify="space-between">
                                                <p>{this.props.language["applyLevel4"]}</p>
                                                <Switch
                                                    checked={
                                                        this.state.handCardConfig.mtt &&
                                                        this.state.handCardConfig.mtt.high
                                                    }
                                                    onChange={(value) =>
                                                        this.handleUpdateConfig(5, "high", value)
                                                    }
                                                />
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* 右侧 */}
                        <Col span={isMobileDevice() ? 24 : 12}>
                            {/* 数据记录 */}
                            <Card
                                title={
                                    <Row type="flex" align="middle" justify="space-between">
                                        <h2>{this.props.language["dataRecord"]}</h2>
                                        {/* <Button
                                            type="default"
                                            icon="arrow-down"
                                            className="btn-yellow-ghost"
                                            loading={this.state.dataRecordExportLoading}
                                            onClick={() => this.handleShow('exportDataRecord')}
                                        >
                                            {this.props.language["exportDataRecord"]}
                                        </Button> */}
                                    </Row>
                                }
                                type="inner"
                            >
                                <Tabs>
                                    {/* 积分记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["intergralRecord"]}
                                        key="integral"
                                    >
                                        <Table
                                            dataSource={this.state.integralData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,

                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                size: isMobileDevice() ? 'small' : '',
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.integralQueryParams.page,
                                                pageSize: this.state.integralQueryParams.limit,
                                                total: this.state.integralQueryParams.total,
                                            }}
                                            loading={this.state.integralLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "integral")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="log_time"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["counterPoint"]}
                                                dataIndex="point"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["type"]}
                                                dataIndex="log_type"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["remark"]}
                                                dataIndex="desc"
                                            />
                                        </Table>
                                    </Tabs.TabPane>

                                    {/* 操作记录 */}
                                    <Tabs.TabPane
                                        tab={this.props.language["operateRecord"]}
                                        key="operate"
                                    >
                                        <div className='container-header p0'>
                                            <DatePicker.RangePicker
                                                value={this.state.operateQueryParams.date}
                                                onChange={(e) =>
                                                    this.handleSetQueryParamsData("date", e, "operate")
                                                }
                                            />
                                        </div>
                                        <Table
                                            className="mt10"
                                            dataSource={this.state.operateData}
                                            pagination={{
                                                showTotal: (total) =>
                                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                                showQuickJumper: true,
                                                showSizeChanger: true,
                                                pageSizeOptions: ["10", "20", "30", "40"],
                                                current: this.state.operateQueryParams.page,
                                                pageSize: this.state.operateQueryParams.limit,
                                                total: this.state.operateQueryParams.total,
                                            }}
                                            loading={this.state.operateLoading}
                                            onChange={(pagination) =>
                                                this.hanldeChangePage(pagination, "operate")
                                            }
                                            scroll={{ x: true }}
                                            rowKey={(record, index) => index}
                                            bordered
                                            size="small"
                                        >
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["unionId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/union_detail/${item.union_id}`}>
                                                        {item.union_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["unionName"]}
                                                dataIndex="union_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/club_detail/${item.club_id}`}>
                                                        {item.club_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["clubName"]}
                                                dataIndex="club_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonId"]}
                                                dataIndex="opt_uid"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonName"]}
                                                dataIndex="opt_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationPersonRole"]}
                                                dataIndex="opt_role_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationType"]}
                                                dataIndex="reason"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationedPlayerId"]}
                                                dataIndex=""
                                                render={(item) => (
                                                    <Link to={`/player_detail/${item.user_id}/${item.club_id}`}>
                                                        {item.user_id || ''}
                                                    </Link>
                                                )}
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationedPlayerName"]}
                                                dataIndex="user_name"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["operationDetail"]}
                                                dataIndex="detail"
                                            />
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["date"]}
                                                dataIndex="tunix"
                                            />
                                        </Table>
                                    </Tabs.TabPane>
                                </Tabs>
                            </Card>
                        </Col>
                    </Row>

                    {/* 表单弹窗 */}
                    <FormModal
                        {...this.props}
                        visible={this.state.show}
                        type={this.state.type}
                        title={this.state.title}
                        formData={this.state.formData}
                        onOk={this.handleSubmit}
                        onCancel={this.handleClose}
                        wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                    />
                </div>
            </Spin >
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 可用占比 */}
                            {this.props.type === "editProportion" && (
                                <>
                                    <Form.Item label={this.props.language["serviceProportion"]}>
                                        {getFieldDecorator("avail_fee_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["serviceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["serviceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["insuranceProportion"]}>
                                        {getFieldDecorator("avail_ins_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["insuranceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["insuranceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyProportion"]}>
                                        {getFieldDecorator("avail_cowboy_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["cowboyProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_cowboy_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["cowboyProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["insuranceDivide"]}>
                                        {getFieldDecorator("ins_mod", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["insuranceDivideVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group style={{ width: "300px" }}>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyDivide"]}>
                                        {getFieldDecorator("cowboy_mod", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["cowboyDivideVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group style={{ width: "300px" }}>
                                                <Radio value={1}>{this.props.language["risk"]}</Radio>
                                                <Radio value={2}>EV</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 发放回收积分/钻石 */}
                            {(this.props.type === "sendIntegral" ||
                                this.props.type === "recycleIntegral" ||
                                this.props.type === "sendDiamond" ||
                                this.props.type === "recycleDiamond") && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator("amount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"],
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 编辑亏损限额 */}
                            {this.props.type === "editLossLimit" && (
                                <>
                                    <Form.Item label={this.props.language["dayLossLimit"]}>
                                        {getFieldDecorator("no_day_limit", {
                                            initialValue: this.props.formData.no_day_limit,
                                            valuePropName: "checked",
                                        })(
                                            <Switch />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('no_day_limit') &&
                                        <>
                                            <Form.Item label={this.props.language["dayLossLimitQuota"]}>
                                                {getFieldDecorator("day_limit", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.language["dayLossLimitQuotaVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.day_limit,
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["dayLossLimitQuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item label={`${this.props.language["dayRemainingRuota"]}（${Number(this.props.formData.add_day_left) + Number(getFieldValue('add_day_left') || 0)}）`}>
                                                {getFieldDecorator("add_day_left", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["dayRemainingRuotaVerify"],
                                                        },
                                                    ],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["dayRemainingRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                        </>
                                    }
                                    <Form.Item label={this.props.language["weekLossLimit"]}>
                                        {getFieldDecorator("no_week_limit", {
                                            initialValue: this.props.formData.no_week_limit,
                                            valuePropName: "checked",
                                        })(
                                            <Switch />
                                        )}
                                    </Form.Item>
                                    {getFieldValue('no_week_limit') &&
                                        <>
                                            <Form.Item label={this.props.language["weekLossLimitRuota"]}>
                                                {getFieldDecorator("week_limit", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.language["weekLossLimitRuotaVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.week_limit,
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["weekLossLimitRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item label={`${this.props.language["weekRemainingRuota"]}（${Number(this.props.formData.add_week_left) + Number(getFieldValue('add_week_left') || 0)}）`}>
                                                {getFieldDecorator("add_week_left", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["weekRemainingRuotaVerify"],
                                                        },
                                                    ],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["weekRemainingRuotaPlaceholder"]}
                                                    />
                                                )}
                                            </Form.Item>
                                        </>
                                    }
                                </>
                            )}

                            {/* 导出数据记录 */}
                            {this.props.type === "exportDataRecord" && (
                                <>
                                    <Form.Item label={this.props.language["timeRange"]}>
                                        {getFieldDecorator("date", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["timeRangeVerify"],
                                                },
                                            ],
                                        })(
                                            <DatePicker.RangePicker />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);
